import { useEffect, useState } from "react";
import "./styles.scss";
import { Button, Icon } from "@/components";
import Chat from "./messages";
import Notifications from "./notifications";
import AvatarImg from "./Frame 194.png";
import Header from "@/layouts/dashboard-layout/header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { Chat as IChat, chatListFetch } from "@/redux/slice/chat/chatList";
import { useAuth } from "@/contexts/auth-context";
import { formatDate, isTimeOver24HoursAgo } from "@/utils/function";
import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";

const notifications = [
  {
    id: 1,
    title: "Welcome To Pluritongues",
    image: "https://via.placeholder.com/600x200",
    content:
      "We here at pluritongues pluritongues pluritongues pluritongues pluritongues...",
    date: "January 15, 2024",
    details: {
      title: "Pluritongues Support",
      image: "https://via.placeholder.com/600x200", // Replace with your image URL
      content: `
        The best way for management, teachers, professors, lecturers, and principals to welcome students is with endearing words that cultivate a sense of trust...
      `,
      date: "Friday 27, October 2024",
    },
  },
];

const NotificationPage = () => {
  const { token } = useAuth();
  const dispatch = useAppDispatch();

  const { data, error, loading } = useAppSelector((state) => state.chatList);

  const navigate = useNavigate();

  const [selectedNotification, setSelectedNotification] = useState(
    notifications[0]
  );
  const [selectedMessage, setSelectedMessage] = useState<IChat>({
    id: "",
    firstName: "",
    lastName: "",
    profilePicture: "",
    teacherId: "",
    senderUserType: "",
    receiver: "",
    sender: "",
    content: "",
    lastMessage: {
      createdAt: "",
      content: "",
      id: "",
    },
  });

  const [activeTab, setActiveTab] = useState<"notification" | "message">(
    "notification"
  );
  const location = useLocation();

  const teacher = location?.state?.teacher;

  useEffect(() => {
    dispatch(chatListFetch({ token: token! }));
  }, [dispatch, token, teacher]);

  useEffect(() => {
    if (teacher) {
      setActiveTab("message");
      setSelectedMessage({
        ...selectedMessage,
        id: teacher.id ? teacher.id : teacher.marchantId,
        firstName: teacher.firstName,
        lastName: teacher.lastName,
        profilePicture: teacher.dpUrl,
        teacherId: teacher.id ? teacher.id : teacher.marchantId,
        senderUserType: "",
        receiver: "",
        sender: "",
        content: "",
        lastMessage: {
          createdAt: "",
          content: "",
          id: "",
        },
      });
    }
  }, [teacher]);

  return (
    <>
      <Header />
      <div className="notification-page">
        <Button
          onClick={() => navigate(-1)}
          variant="neutral"
          className="go-back"
        >
          <Icon name="left_arrow" />
          Back
        </Button>

        {/* Page Title */}
        <h1 className="page-title">Message & Notifications</h1>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="notification-container">
            {/* Notifications List */}
            <div className="notification-list">
              <div className="tabs">
                <button
                  className={`tab ${
                    activeTab === "notification" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("notification")}
                >
                  Notification
                </button>
                <button
                  className={`tab ${activeTab === "message" ? "active" : ""}`}
                  onClick={() => setActiveTab("message")}
                >
                  Message
                </button>
              </div>
              {activeTab === "notification" &&
                notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`notification-item ${
                      selectedNotification.id === notification.id
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      setSelectedNotification(notification);
                    }}
                  >
                    <div className="image-container">
                      <img src={AvatarImg} alt="Avatar" />
                    </div>
                    <div className="text-container">
                      <h2 className="notification-title">
                        {notification.title}
                      </h2>
                      <p className="notification-content">
                        {notification.content}
                      </p>
                      <p className="notification-date">{notification.date}</p>
                    </div>
                  </div>
                ))}
              {activeTab === "message" &&
                data.map((message) => (
                  <div
                    key={message.teacherId}
                    className={`notification-item ${
                      selectedMessage.teacherId === message.teacherId
                        ? "active"
                        : ""
                    }`}
                    onClick={() => setSelectedMessage(message)}
                  >
                    <div className="image-container">
                      <img
                        src={message.profilePicture || "default-image.png"}
                        alt="Avatar"
                      />
                    </div>
                    <div className="text-container">
                      <h2 className="notification-title">{`${message.firstName} ${message.lastName}`}</h2>
                      <p className="notification-content">
                        {message.lastMessage.content}
                      </p>
                      <p className="notification-date">
                        {isTimeOver24HoursAgo(message?.lastMessage?.createdAt)
                          ? new Date(
                              message?.lastMessage?.createdAt
                            ).toLocaleDateString()
                          : new Date(
                              message?.lastMessage?.createdAt
                            ).toLocaleTimeString()}
                      </p>
                    </div>
                  </div>
                ))}
            </div>

            {activeTab === "message" && selectedMessage.id !== "" ? (
              <div className="notification-details">
                <Chat
                  setSelectedMessage={setSelectedMessage}
                  selectedMessage={selectedMessage}
                />
              </div>
            ) : activeTab === "notification" && selectedNotification ? (
              <div className="notification-details">
                <Notifications
                  selectedNotification={selectedNotification}
                  // setShow={setShow}
                />
              </div>
            ) : null}
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationPage;
